/**
 * recently-viewed.js
 *
 * 1. Трекинг — при загрузке страницы товара сохраняет product.id
 *    в localStorage (читает из data-rv-product-id).
 *
 * 2. Рендер — для каждого [data-rv-container] на странице запрашивает
 *    секцию через Shopify Section Rendering API и вставляет HTML.
 *
 * Запрос: GET /?sections=<section.id>&rv_ids=111,222,333
 * Ответ:  JSON { "<section.id>": "<html>" }
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'rv_products';
  const MAX_ITEMS   = 10;

  /* ─── localStorage ───────────────────────────────────────────────── */

  function getIds() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveIds(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch { /* приватный режим и т.п. */ }
  }

  /** Добавляет id в начало; убирает дубли; обрезает до MAX_ITEMS. */
  function pushProduct(productId) {
    if (!productId) return;
    const id  = String(productId);
    const ids = getIds().filter((x) => x !== id);
    ids.unshift(id);
    saveIds(ids.slice(0, MAX_ITEMS));
  }

  /* ─── Трекинг текущего товара ────────────────────────────────────── */

  // Секция сама выводит data-rv-product-id на странице товара
  const trackEl   = document.querySelector('[data-rv-product-id]');
  const currentId = trackEl ? trackEl.dataset.rvProductId : null;
  if (currentId) pushProduct(currentId);

  /* ─── Рендер одного контейнера ───────────────────────────────────── */

  async function fillContainer(container) {
    const sectionId = container.dataset.rvSection;
    if (!sectionId) return;

    // Текущий товар не показываем в блоке «недавно просмотренные»
    const ids = getIds().filter((id) => id !== currentId);
    if (ids.length === 0) return;

    const url = `/?sections=${encodeURIComponent(sectionId)}&rv_ids=${ids.join(',')}`;

    try {
      const res = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const json = await res.json();
      const html = json[sectionId];
      if (!html) return;

      // Shopify оборачивает ответ в <div id="shopify-section-<id>">.
      // Берём содержимое этой обёртки, чтобы не дублировать wrapper.
      const tmp   = document.createElement('div');
      tmp.innerHTML = html;
      const inner = tmp.querySelector(`#shopify-section-${sectionId}`);

      container.innerHTML = inner ? inner.innerHTML : html;
      container.hidden    = false;

      // Если товары не нашлись — Liquid вернёт пустой HTML,
      // скрываем весь wrapper чтобы не торчала пустая секция.
      if (!container.children.length) {
        const wrapper = container.closest('[data-rv-wrapper]');
        if (wrapper) wrapper.hidden = true;
      }
    } catch (err) {
      console.warn('[RecentlyViewed] Ошибка загрузки секции:', err);
    }
  }

  /* ─── Заполняем все контейнеры на странице ───────────────────────── */

  function renderAll() {
    const containers = document.querySelectorAll('[data-rv-container]');
    containers.forEach(fillContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }

  /* Публичное API — можно вызвать вручную при необходимости */
  window.RecentlyViewed = { push: pushProduct, getIds, render: renderAll };
})();